import { Formik } from "formik";
import React, { useState } from "react";
import { API, get, IV, post, SECRETKEY } from "../../config";
import CryptoJS from "crypto-js";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Eye, EyeClosedIcon } from "lucide-react";
import { Button } from "../../components/ui/button";
import { ChangePasswordSchema } from "../../lib/Validation";
import CustomLabelText from "../../components/CustomLabelText";

const ChangePassword = ({ setLoading, loading }) => {
  const iv = IV;
  const key = SECRETKEY;

  const fkey = CryptoJS.enc.Utf8.parse(key);
  const fiv = CryptoJS.enc.Utf8.parse(iv);
  const [showOldPassword, setShowOldPassword] = useState(false);

  const toggleShowOldPassword = () => {
    setShowOldPassword(!showOldPassword);
  };
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const [showPassword2, setShowPassword2] = useState(false);

  const toggleShowPassword2 = () => {
    setShowPassword2(!showPassword2);
  };

  const logout = () => {
    get(API.LOGOUT)
      .then((response) => {
        if (response.status === 200) {
          localStorage.clear();
          window.location.href = "/";
        }
      })
      .catch(() => {
        var error = {};
        error["bt_error"] =
          "There is some issue with request, please try after some time.";
        this.setState({ errors: error });
      });
  };

  const handleFormSubmit = async (values) => {
    try {
      setLoading(true);

      const encOldPassword = CryptoJS.AES.encrypt(values?.old_password, fkey, {
        iv: fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const finalEncryptedOldPassword = encOldPassword.ciphertext.toString(
        CryptoJS.enc.Base64
      );

      const encNewPassword = CryptoJS.AES.encrypt(values?.new_password, fkey, {
        iv: fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const finalEncryptedNewPassword = encNewPassword.ciphertext.toString(
        CryptoJS.enc.Base64
      );

      const encConfirmPassword = CryptoJS.AES.encrypt(
        values?.password_confirmation,
        fkey,
        {
          iv: fiv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      const finalEncryptedConfirmPassword =
        encConfirmPassword.ciphertext.toString(CryptoJS.enc.Base64);

      const finalValue = {
        ...values,
        old_password: finalEncryptedOldPassword,
        new_password: finalEncryptedNewPassword,
        confirm_password: finalEncryptedConfirmPassword,
      };

      const { data } = await post(API.CHANGE_PASSWORD, finalValue);
      if (data.status === 200) {
        setLoading(false);
        logout();
      }
    } catch (e) {
      setLoading(false);
    }
  };
  return (
    <Formik
      initialValues={{
        old_password: "",
        new_password: "",
        password_confirmation: "",
      }}
      enableReinitialize
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={ChangePasswordSchema}
      onSubmit={handleFormSubmit}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        setFieldValue,
        handleSubmit,
        isValid,
      }) => (
        <form onSubmit={handleSubmit} noValidate>
          <div>
            <div className="md:flex gap-5">
              <div className="grid gap-4 flex-1">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="old_password">
                      <CustomLabelText
                        required={true}
                        labelText="Old Password"
                        errorField={errors?.old_password}
                      />
                    </Label>

                    <div className="relative">
                      <Input
                        id="old_password"
                        name="old_password"
                        type={showOldPassword ? "text" : "password"}
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.old_password}
                        autocomplete="off"
                        className={
                          errors?.old_password &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                      {showOldPassword ? (
                        <span className="absolute top-2 right-2">
                          <Eye
                            width={20}
                            height={20}
                            onClick={toggleShowOldPassword}
                          />
                        </span>
                      ) : (
                        <span className="absolute top-2 right-2">
                          <EyeClosedIcon
                            width={20}
                            height={20}
                            onClick={toggleShowOldPassword}
                          />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="new_password">
                      <CustomLabelText
                        required={true}
                        labelText="New Password"
                        errorField={errors?.new_password}
                      />
                    </Label>

                    <div className="relative">
                      <Input
                        id="new_password"
                        name="new_password"
                        type={showPassword ? "text" : "password"}
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.new_password}
                        autocomplete="off"
                        className={
                          errors?.new_password &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                      {showPassword ? (
                        <span className="absolute top-2 right-2">
                          <Eye
                            width={20}
                            height={20}
                            onClick={toggleShowPassword}
                          />
                        </span>
                      ) : (
                        <span className="absolute top-2 right-2">
                          <EyeClosedIcon
                            width={20}
                            height={20}
                            onClick={toggleShowPassword}
                          />
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="password_confirmation">
                      {" "}
                      <CustomLabelText
                        required={true}
                        labelText="Confirm Password"
                        errorField={errors?.password_confirmation}
                      />
                    </Label>

                    <div className="relative">
                      <Input
                        id="password"
                        name="password_confirmation"
                        type={showPassword2 ? "text" : "password"}
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password_confirmation}
                        autocomplete="off"
                        className={
                          errors?.password_confirmation &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                      {showPassword2 ? (
                        <span className="absolute top-2 right-2">
                          <Eye
                            width={20}
                            height={20}
                            onClick={toggleShowPassword2}
                          />
                        </span>
                      ) : (
                        <span className="absolute top-2 right-2">
                          <EyeClosedIcon
                            width={20}
                            height={20}
                            onClick={toggleShowPassword2}
                          />
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-action">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ChangePassword;
